import { DataSizeUnit } from '@/utils/helpers/fileSize.helpers';
import { IFileSize } from '@/types/fileSize.types';

export const MAX_FILES_AMOUNT: number = 50;

export const ATTACHMENT_FILE_SIZE: IFileSize = {
  size: 50,
  unit: DataSizeUnit.MB,
};

export const MAX_ATTACHMENT_FILE_SIZE_BYTES = ATTACHMENT_FILE_SIZE.size * 1_000_000;
